<div class="session bg-primary">
  <div class="session-content">
    <div class="flex-box" class="flex-box-monkey">
      <img src="assets/images/monkey-1.png" alt="Monkey" title="Monkey" class="monkey-1" />
      <img src="assets/images/monkey-2.png" alt="Monkey" title="Monkey" class="monkey-2" />
      <mat-card class="flex-card width-card">
        <mat-card-content>
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="text-xs-center">
              <img src="assets/images/logo.png" alt="Smart contact" title="Smart contact" width="150" />
            </div>
            <div class="text-xs-center pb-1" *ngIf="!isProjectSuperAdmin && domainName">
              <h2 class="domain-name mt-2" [innerHTML]=" 'login.login_domain' | translate:{ domain: enterpriseName } ">
              </h2>
              <a data-ci="change-domain" (click)="goEnterpriseSelect()"
                class="mat-text-primary d-inline link-signin">{{ 'menu.connect_other_enterprise_hint' | translate }}</a>
            </div>
            <p data-ci="reset-error" class="mat-error mb-0" *ngIf="errorMessage">{{ errorMessage }}</p>
            <p *ngIf="instruction" class="text-xs-center pb-1">
              <i>{{ instruction|translate }}</i>
            </p>
            <div fxLayout="column" fxLayoutAlign="space-around">
              <div class="pb-1">
                <input matInput placeholder="{{ 'register.form.email'|translate }}" type="email" id="email"
                  [formControl]="form.controls['email']">
                <small data-ci="reset-error"
                  *ngIf="form.controls['email'].hasError('required') && form.controls['email'].touched"
                  class="mat-text-warn">{{ 'public.message.email_invalid'|translate }}</small>
                <small data-ci="reset-error"
                  *ngIf="form.controls['email'].errors?.email && form.controls['email'].touched"
                  class="mat-text-warn">{{ 'public.message.email_invalid'|translate }}</small>
                <small data-ci="reset-error" *ngIf="form.controls['email'].errors?.invalid_email"
                  class="mat-text-warn">{{ 'public.message.email_invalid'|translate }}</small>
                <small data-ci="reset-error" *ngIf="form.controls['email'].errors?.password_request_inprogress"
                  class="mat-text-warn">{{ 'resetpass.request_inprogress'|translate }}</small>
                <small data-ci="reset-error" *ngIf="form.controls['email'].errors?.invalid_domain"
                  class="mat-text-warn">{{ 'register.validator.domain_invalid'|translate }}</small>
                <small data-ci="reset-error" *ngIf="form.controls['email'].errors?.unknown"
                  class="mat-text-warn">{{ form.controls['email'].errors.unknown }}</small>
              </div>
              <button mat-raised-button class="login-button gradient-background" type="submit"
                [disabled]="alreadysubmit">{{ 'public.reset'|translate }}</button>
            </div>
            <div class="pt-1 pb-1 text-xs-center">
              <a [routerLink]="['/s/signin']">{{ 'login.login'|translate }}</a>&nbsp;&nbsp;&nbsp;&nbsp;
              <a *ngIf="!isProjectSuperAdmin" [href]="linkSignup">{{ 'login.create_new_account'|translate }}</a>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
